import { supabase } from '@/integrations/supabase/client';

export type TermAction = 'create' | 'edit' | 'discard' | 'publish';

interface LogTermActionParams {
  termId: string;
  action: TermAction;
  userId: string;
  userName: string;
  details?: Record<string, unknown>;
}

export const logTermAction = async ({ 
  termId, 
  action, 
  userId, 
  userName, 
  details 
}: LogTermActionParams): Promise<void> => {
  try {
    // Usa RPC ou insert direto com cast para contornar tipos desatualizados
    const { error } = await supabase
      .from('terms_of_use_logs' as any)
      .insert({
        term_id: termId,
        action,
        performed_by_user_id: userId,
        performed_by_user_name: userName,
        details: details || null
      } as any);
    
    if (error) {
      console.error('Erro ao registrar log de termo:', error);
    }
  } catch (err) {
    console.error('Erro ao registrar log de termo:', err);
  }
};
